import { CountertopPanel } from '../countertop.interface';

export class SimpleCountertopPanel implements CountertopPanel {
  uid: string;

  length: number;
  width: number;

  constructor(length: number, width: number) {
    this.length = length;
    this.width = width;

    this.uid = crypto.randomUUID();
  }
}
